'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCreateRequest() {
}
export { $c_Lapp_data_AppDocumentDataCreateRequest as $c_Lapp_data_AppDocumentDataCreateRequest };
$p = $c_Lapp_data_AppDocumentDataCreateRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataCreateRequest;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCreateRequest() {
}
export { $h_Lapp_data_AppDocumentDataCreateRequest as $h_Lapp_data_AppDocumentDataCreateRequest };
$h_Lapp_data_AppDocumentDataCreateRequest.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
function $isArrayOf_Lapp_data_AppDocumentDataCreateRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dC)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataCreateRequest as $isArrayOf_Lapp_data_AppDocumentDataCreateRequest };
//# sourceMappingURL=app.data.-App-Document-Data-Create-Request.js.map
